import constants from './constants'

const key = window.location.hostname

export const LOCAL_STORAGE = {
  lastWalletCache: `${key}_last_wallet_cache_${constants.NETWORK}`,
  signatureCache: `${key}_signature_cache_${constants.NETWORK}`,
  signatureMessageCache: `${key}_signature_message_cache_${constants.NETWORK}`,
  userTokenCache: `${key}_user_token_cache_${constants.NETWORK}`,
  lastSignIn: `${key}_last_sign_in_${constants.NETWORK}`,
  preferredCurrency: `${key}_preferred_currency_${constants.NETWORK}`,
  hasSeenFilters: `${key}_has_filtered_${constants.NETWORK}`,
  userCart: `${key}_user_cart_${constants.NETWORK}`
}

/**
 * The key used for viewing an avatar
 *
 * @param {string|number} id - the avatar id
 * @returns {string} the local storage key
 */
export const getAvatarLocalStorageKey = id =>
  `${key}_avatar_${id}_viewed_${constants.NETWORK}`

/**
 * The key used for viewing an avatar
 *
 * @param {string|number} id - the avatar id
 * @returns {string} the local storage key
 */
export const getAccessoryLocalStorageKey = id =>
  `${key}_accessory_${id}_viewed_${constants.NETWORK}`
